import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { AuthContext } from '../../context/Auth.context';
import withRouter from '../WithRouter';

import styles from './Layout.module.scss';
import { ROUTES } from '../../constants/routes';

const Layout = ({ children, location, navigate }) => {
  const [authState] = useContext(AuthContext);
  const isAuthenticated = authState.isAuthenticated;
  
  useEffect(() => {
    if (location?.pathname.includes(ROUTES.blueSkyRulesPath)) {
      window.scrollTo(0, 0);
    }
  }, [location]);

  useEffect(() => {
    if (location.search) {
      const newLocation = { ...location, search: '' };

      navigate(newLocation);
    }
  }, [isAuthenticated]);

  return <>
    {isAuthenticated && <div className={styles.container}>
      <main>{children}</main>
    </div>}
  </>;
};

Layout.propTypes = {
  children: PropTypes.node,
  location: PropTypes.object,
  navigate: PropTypes.func
};


export default withRouter(Layout);
